module.exports = __webpack_public_path__ + "images/mobile/icon-doc-427834fe766d15f07548b73a80f69699.png";